import * as pe from "react";
import _, { useCallback as Me, memo as pr, useRef as Ct, forwardRef as ba, useEffect as at, useState as Aa, useMemo as Pa } from "react";
import Oa, { Box as ie, Toast as Ta, IconButton as Na, IconChevronRight as Ia, IconChevronLeft as La, Carousel as $a, Heading as ya, Text as wa, PropertyCard as K, Button as xa, IconArrowRightOutline as Ma, PhotoCarousel as Fa, Anchor as Mt, withToast as Ua } from "@zillow/constellation";
import { withTheme as Cr } from "styled-components";
import { track as Fe, event as Da } from "@zillow/universal-analytics";
import { gql as Rr, useMutation as Ft } from "@apollo/client";
function Ue(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const a in n)
        if (a !== "default" && !(a in e)) {
          const i = Object.getOwnPropertyDescriptor(n, a);
          i && Object.defineProperty(e, a, i.get ? i : {
            enumerable: !0,
            get: () => n[a]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function ye(e) {
  return !!e;
}
function Ba(e) {
  if (!e.zpid)
    throw new Error("zpid is required for HomeRecCard");
}
const ka = "newConstruction", Ha = "auction", Ga = "forRent", za = "MLS® ID #", ja = "MLS ID #", Wa = 8, Va = 4, Ut = 380, Ya = 285, qa = 345, Za = 1e4, Ka = "We're unable to save. Try refreshing this page.", Ja = "We're unable to un-save. Try refreshing this page.", Xa = () => _.createElement(ie, { role: "alert", "aria-busy": "true", sx: {
  animationDuration: "1.5s",
  animationFillMode: "forwards",
  animationIterationCount: "infinite",
  animationTimingFunction: "linear",
  backgroundImage: "$PropertyCard.loading.backgroundImage",
  backgroundColor: "$PropertyCard.loading.backgroundColor",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  height: "100%",
  width: "100%",
  position: "relative",
  "@keyframes shimmer": {
    "0%": {
      backgroundPosition: "-600px 0"
    },
    "100%": {
      backgroundPosition: "600px 0"
    }
  },
  animationName: "shimmer"
} }), W = (e, t = null, r = 0) => Me(
  (...n) => {
    typeof e == "function" && requestAnimationFrame(() => setTimeout(() => e(...n), r));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [...t ? [...t] : [e], r]
);
function de(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Re = {}, P = {}, Qa = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function ei(e) {
  return e.match(Qa) || [];
}
var ti = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function ri(e) {
  return ti.test(e);
}
var ni = typeof global == "object" && global && global.Object === Object && global;
const Sr = ni;
var ai = typeof self == "object" && self && self.Object === Object && self, ii = Sr || ai || Function("return this")();
const H = ii;
var oi = H.Symbol;
const Y = oi;
function ui(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var si = Array.isArray;
const k = si;
var Er = Object.prototype, ci = Er.hasOwnProperty, li = Er.toString, Ce = Y ? Y.toStringTag : void 0;
function fi(e) {
  var t = ci.call(e, Ce), r = e[Ce];
  try {
    e[Ce] = void 0;
    var n = !0;
  } catch {
  }
  var a = li.call(e);
  return n && (t ? e[Ce] = r : delete e[Ce]), a;
}
var di = Object.prototype, gi = di.toString;
function _i(e) {
  return gi.call(e);
}
var mi = "[object Null]", vi = "[object Undefined]", Dt = Y ? Y.toStringTag : void 0;
function ge(e) {
  return e == null ? e === void 0 ? vi : mi : Dt && Dt in Object(e) ? fi(e) : _i(e);
}
function ce(e) {
  return e != null && typeof e == "object";
}
var hi = "[object Symbol]";
function De(e) {
  return typeof e == "symbol" || ce(e) && ge(e) == hi;
}
var pi = 1 / 0, Bt = Y ? Y.prototype : void 0, kt = Bt ? Bt.toString : void 0;
function br(e) {
  if (typeof e == "string")
    return e;
  if (k(e))
    return ui(e, br) + "";
  if (De(e))
    return kt ? kt.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -pi ? "-0" : t;
}
function Pe(e) {
  return e == null ? "" : br(e);
}
var Ar = "\\ud800-\\udfff", Ci = "\\u0300-\\u036f", Ri = "\\ufe20-\\ufe2f", Si = "\\u20d0-\\u20ff", Ei = Ci + Ri + Si, Pr = "\\u2700-\\u27bf", Or = "a-z\\xdf-\\xf6\\xf8-\\xff", bi = "\\xac\\xb1\\xd7\\xf7", Ai = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Pi = "\\u2000-\\u206f", Oi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Tr = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ti = "\\ufe0e\\ufe0f", Nr = bi + Ai + Pi + Oi, Ir = "['’]", Ht = "[" + Nr + "]", Ni = "[" + Ei + "]", Lr = "\\d+", Ii = "[" + Pr + "]", $r = "[" + Or + "]", yr = "[^" + Ar + Nr + Lr + Pr + Or + Tr + "]", Li = "\\ud83c[\\udffb-\\udfff]", $i = "(?:" + Ni + "|" + Li + ")", yi = "[^" + Ar + "]", wr = "(?:\\ud83c[\\udde6-\\uddff]){2}", xr = "[\\ud800-\\udbff][\\udc00-\\udfff]", oe = "[" + Tr + "]", wi = "\\u200d", Gt = "(?:" + $r + "|" + yr + ")", xi = "(?:" + oe + "|" + yr + ")", zt = "(?:" + Ir + "(?:d|ll|m|re|s|t|ve))?", jt = "(?:" + Ir + "(?:D|LL|M|RE|S|T|VE))?", Mr = $i + "?", Fr = "[" + Ti + "]?", Mi = "(?:" + wi + "(?:" + [yi, wr, xr].join("|") + ")" + Fr + Mr + ")*", Fi = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ui = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Di = Fr + Mr + Mi, Bi = "(?:" + [Ii, wr, xr].join("|") + ")" + Di, ki = RegExp([
  oe + "?" + $r + "+" + zt + "(?=" + [Ht, oe, "$"].join("|") + ")",
  xi + "+" + jt + "(?=" + [Ht, oe + Gt, "$"].join("|") + ")",
  oe + "?" + Gt + "+" + zt,
  oe + "+" + jt,
  Ui,
  Fi,
  Lr,
  Bi
].join("|"), "g");
function Hi(e) {
  return e.match(ki) || [];
}
function it(e, t, r) {
  return e = Pe(e), t = r ? void 0 : t, t === void 0 ? ri(e) ? Hi(e) : ei(e) : e.match(t) || [];
}
function Ur(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
function Gi(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var s = o[e ? u : ++a];
      if (r(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var zi = Gi();
const ji = zi;
function Wi(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Vi = "[object Arguments]";
function Wt(e) {
  return ce(e) && ge(e) == Vi;
}
var Dr = Object.prototype, Yi = Dr.hasOwnProperty, qi = Dr.propertyIsEnumerable, Zi = Wt(function() {
  return arguments;
}()) ? Wt : function(e) {
  return ce(e) && Yi.call(e, "callee") && !qi.call(e, "callee");
};
const Br = Zi;
function Ki() {
  return !1;
}
var kr = typeof exports == "object" && exports && !exports.nodeType && exports, Vt = kr && typeof module == "object" && module && !module.nodeType && module, Ji = Vt && Vt.exports === kr, Yt = Ji ? H.Buffer : void 0, Xi = Yt ? Yt.isBuffer : void 0, Qi = Xi || Ki;
const ot = Qi;
var eo = 9007199254740991, to = /^(?:0|[1-9]\d*)$/;
function Hr(e, t) {
  var r = typeof e;
  return t = t ?? eo, !!t && (r == "number" || r != "symbol" && to.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ro = 9007199254740991;
function Rt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ro;
}
var no = "[object Arguments]", ao = "[object Array]", io = "[object Boolean]", oo = "[object Date]", uo = "[object Error]", so = "[object Function]", co = "[object Map]", lo = "[object Number]", fo = "[object Object]", go = "[object RegExp]", _o = "[object Set]", mo = "[object String]", vo = "[object WeakMap]", ho = "[object ArrayBuffer]", po = "[object DataView]", Co = "[object Float32Array]", Ro = "[object Float64Array]", So = "[object Int8Array]", Eo = "[object Int16Array]", bo = "[object Int32Array]", Ao = "[object Uint8Array]", Po = "[object Uint8ClampedArray]", Oo = "[object Uint16Array]", To = "[object Uint32Array]", p = {};
p[Co] = p[Ro] = p[So] = p[Eo] = p[bo] = p[Ao] = p[Po] = p[Oo] = p[To] = !0;
p[no] = p[ao] = p[ho] = p[io] = p[po] = p[oo] = p[uo] = p[so] = p[co] = p[lo] = p[fo] = p[go] = p[_o] = p[mo] = p[vo] = !1;
function No(e) {
  return ce(e) && Rt(e.length) && !!p[ge(e)];
}
function Io(e) {
  return function(t) {
    return e(t);
  };
}
var Gr = typeof exports == "object" && exports && !exports.nodeType && exports, Se = Gr && typeof module == "object" && module && !module.nodeType && module, Lo = Se && Se.exports === Gr, Ke = Lo && Sr.process, $o = function() {
  try {
    var e = Se && Se.require && Se.require("util").types;
    return e || Ke && Ke.binding && Ke.binding("util");
  } catch {
  }
}();
const qt = $o;
var Zt = qt && qt.isTypedArray, yo = Zt ? Io(Zt) : No;
const zr = yo;
var wo = Object.prototype, xo = wo.hasOwnProperty;
function Mo(e, t) {
  var r = k(e), n = !r && Br(e), a = !r && !n && ot(e), i = !r && !n && !a && zr(e), o = r || n || a || i, u = o ? Wi(e.length, String) : [], s = u.length;
  for (var c in e)
    (t || xo.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Hr(c, s))) && u.push(c);
  return u;
}
var Fo = Object.prototype;
function Uo(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Fo;
  return e === r;
}
function Do(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Bo = Do(Object.keys, Object);
const ko = Bo;
var Ho = Object.prototype, Go = Ho.hasOwnProperty;
function zo(e) {
  if (!Uo(e))
    return ko(e);
  var t = [];
  for (var r in Object(e))
    Go.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function le(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var jo = "[object AsyncFunction]", Wo = "[object Function]", Vo = "[object GeneratorFunction]", Yo = "[object Proxy]";
function jr(e) {
  if (!le(e))
    return !1;
  var t = ge(e);
  return t == Wo || t == Vo || t == jo || t == Yo;
}
function Wr(e) {
  return e != null && Rt(e.length) && !jr(e);
}
function St(e) {
  return Wr(e) ? Mo(e) : zo(e);
}
function qo(e, t) {
  return e && ji(e, t, St);
}
function Zo(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Wr(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var Ko = Zo(qo);
const Jo = Ko;
function Xo(e, t) {
  var r = [];
  return Jo(e, function(n, a, i) {
    t(n, a, i) && r.push(n);
  }), r;
}
function Qo() {
  this.__data__ = [], this.size = 0;
}
function Vr(e, t) {
  return e === t || e !== e && t !== t;
}
function Be(e, t) {
  for (var r = e.length; r--; )
    if (Vr(e[r][0], t))
      return r;
  return -1;
}
var eu = Array.prototype, tu = eu.splice;
function ru(e) {
  var t = this.__data__, r = Be(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : tu.call(t, r, 1), --this.size, !0;
}
function nu(e) {
  var t = this.__data__, r = Be(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function au(e) {
  return Be(this.__data__, e) > -1;
}
function iu(e, t) {
  var r = this.__data__, n = Be(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function z(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
z.prototype.clear = Qo;
z.prototype.delete = ru;
z.prototype.get = nu;
z.prototype.has = au;
z.prototype.set = iu;
function ou() {
  this.__data__ = new z(), this.size = 0;
}
function uu(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function su(e) {
  return this.__data__.get(e);
}
function cu(e) {
  return this.__data__.has(e);
}
var lu = H["__core-js_shared__"];
const Je = lu;
var Kt = function() {
  var e = /[^.]+$/.exec(Je && Je.keys && Je.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function fu(e) {
  return !!Kt && Kt in e;
}
var du = Function.prototype, gu = du.toString;
function ee(e) {
  if (e != null) {
    try {
      return gu.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var _u = /[\\^$.*+?()[\]{}|]/g, mu = /^\[object .+?Constructor\]$/, vu = Function.prototype, hu = Object.prototype, pu = vu.toString, Cu = hu.hasOwnProperty, Ru = RegExp(
  "^" + pu.call(Cu).replace(_u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Su(e) {
  if (!le(e) || fu(e))
    return !1;
  var t = jr(e) ? Ru : mu;
  return t.test(ee(e));
}
function Eu(e, t) {
  return e == null ? void 0 : e[t];
}
function _e(e, t) {
  var r = Eu(e, t);
  return Su(r) ? r : void 0;
}
var bu = _e(H, "Map");
const Ee = bu;
var Au = _e(Object, "create");
const be = Au;
function Pu() {
  this.__data__ = be ? be(null) : {}, this.size = 0;
}
function Ou(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Tu = "__lodash_hash_undefined__", Nu = Object.prototype, Iu = Nu.hasOwnProperty;
function Lu(e) {
  var t = this.__data__;
  if (be) {
    var r = t[e];
    return r === Tu ? void 0 : r;
  }
  return Iu.call(t, e) ? t[e] : void 0;
}
var $u = Object.prototype, yu = $u.hasOwnProperty;
function wu(e) {
  var t = this.__data__;
  return be ? t[e] !== void 0 : yu.call(t, e);
}
var xu = "__lodash_hash_undefined__";
function Mu(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = be && t === void 0 ? xu : t, this;
}
function X(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
X.prototype.clear = Pu;
X.prototype.delete = Ou;
X.prototype.get = Lu;
X.prototype.has = wu;
X.prototype.set = Mu;
function Fu() {
  this.size = 0, this.__data__ = {
    hash: new X(),
    map: new (Ee || z)(),
    string: new X()
  };
}
function Uu(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ke(e, t) {
  var r = e.__data__;
  return Uu(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Du(e) {
  var t = ke(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Bu(e) {
  return ke(this, e).get(e);
}
function ku(e) {
  return ke(this, e).has(e);
}
function Hu(e, t) {
  var r = ke(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function j(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
j.prototype.clear = Fu;
j.prototype.delete = Du;
j.prototype.get = Bu;
j.prototype.has = ku;
j.prototype.set = Hu;
var Gu = 200;
function zu(e, t) {
  var r = this.__data__;
  if (r instanceof z) {
    var n = r.__data__;
    if (!Ee || n.length < Gu - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new j(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function G(e) {
  var t = this.__data__ = new z(e);
  this.size = t.size;
}
G.prototype.clear = ou;
G.prototype.delete = uu;
G.prototype.get = su;
G.prototype.has = cu;
G.prototype.set = zu;
var ju = "__lodash_hash_undefined__";
function Wu(e) {
  return this.__data__.set(e, ju), this;
}
function Vu(e) {
  return this.__data__.has(e);
}
function we(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new j(); ++t < r; )
    this.add(e[t]);
}
we.prototype.add = we.prototype.push = Wu;
we.prototype.has = Vu;
function Yu(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function qu(e, t) {
  return e.has(t);
}
var Zu = 1, Ku = 2;
function Yr(e, t, r, n, a, i) {
  var o = r & Zu, u = e.length, s = t.length;
  if (u != s && !(o && s > u))
    return !1;
  var c = i.get(e), l = i.get(t);
  if (c && l)
    return c == t && l == e;
  var d = -1, g = !0, f = r & Ku ? new we() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < u; ) {
    var v = e[d], C = t[d];
    if (n)
      var E = o ? n(C, v, d, t, e, i) : n(v, C, d, e, t, i);
    if (E !== void 0) {
      if (E)
        continue;
      g = !1;
      break;
    }
    if (f) {
      if (!Yu(t, function(A, h) {
        if (!qu(f, h) && (v === A || a(v, A, r, n, i)))
          return f.push(h);
      })) {
        g = !1;
        break;
      }
    } else if (!(v === C || a(v, C, r, n, i))) {
      g = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), g;
}
var Ju = H.Uint8Array;
const Jt = Ju;
function Xu(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function Qu(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var es = 1, ts = 2, rs = "[object Boolean]", ns = "[object Date]", as = "[object Error]", is = "[object Map]", os = "[object Number]", us = "[object RegExp]", ss = "[object Set]", cs = "[object String]", ls = "[object Symbol]", fs = "[object ArrayBuffer]", ds = "[object DataView]", Xt = Y ? Y.prototype : void 0, Xe = Xt ? Xt.valueOf : void 0;
function gs(e, t, r, n, a, i, o) {
  switch (r) {
    case ds:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case fs:
      return !(e.byteLength != t.byteLength || !i(new Jt(e), new Jt(t)));
    case rs:
    case ns:
    case os:
      return Vr(+e, +t);
    case as:
      return e.name == t.name && e.message == t.message;
    case us:
    case cs:
      return e == t + "";
    case is:
      var u = Xu;
    case ss:
      var s = n & es;
      if (u || (u = Qu), e.size != t.size && !s)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= ts, o.set(e, t);
      var l = Yr(u(e), u(t), n, a, i, o);
      return o.delete(e), l;
    case ls:
      if (Xe)
        return Xe.call(e) == Xe.call(t);
  }
  return !1;
}
function _s(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
function ms(e, t, r) {
  var n = t(e);
  return k(e) ? n : _s(n, r(e));
}
function vs() {
  return [];
}
var hs = Object.prototype, ps = hs.propertyIsEnumerable, Qt = Object.getOwnPropertySymbols, Cs = Qt ? function(e) {
  return e == null ? [] : (e = Object(e), Ur(Qt(e), function(t) {
    return ps.call(e, t);
  }));
} : vs;
const Rs = Cs;
function er(e) {
  return ms(e, St, Rs);
}
var Ss = 1, Es = Object.prototype, bs = Es.hasOwnProperty;
function As(e, t, r, n, a, i) {
  var o = r & Ss, u = er(e), s = u.length, c = er(t), l = c.length;
  if (s != l && !o)
    return !1;
  for (var d = s; d--; ) {
    var g = u[d];
    if (!(o ? g in t : bs.call(t, g)))
      return !1;
  }
  var f = i.get(e), v = i.get(t);
  if (f && v)
    return f == t && v == e;
  var C = !0;
  i.set(e, t), i.set(t, e);
  for (var E = o; ++d < s; ) {
    g = u[d];
    var A = e[g], h = t[g];
    if (n)
      var N = o ? n(h, A, g, t, e, i) : n(A, h, g, e, t, i);
    if (!(N === void 0 ? A === h || a(A, h, r, n, i) : N)) {
      C = !1;
      break;
    }
    E || (E = g == "constructor");
  }
  if (C && !E) {
    var I = e.constructor, T = t.constructor;
    I != T && "constructor" in e && "constructor" in t && !(typeof I == "function" && I instanceof I && typeof T == "function" && T instanceof T) && (C = !1);
  }
  return i.delete(e), i.delete(t), C;
}
var Ps = _e(H, "DataView");
const ut = Ps;
var Os = _e(H, "Promise");
const st = Os;
var Ts = _e(H, "Set");
const ct = Ts;
var Ns = _e(H, "WeakMap");
const lt = Ns;
var tr = "[object Map]", Is = "[object Object]", rr = "[object Promise]", nr = "[object Set]", ar = "[object WeakMap]", ir = "[object DataView]", Ls = ee(ut), $s = ee(Ee), ys = ee(st), ws = ee(ct), xs = ee(lt), J = ge;
(ut && J(new ut(new ArrayBuffer(1))) != ir || Ee && J(new Ee()) != tr || st && J(st.resolve()) != rr || ct && J(new ct()) != nr || lt && J(new lt()) != ar) && (J = function(e) {
  var t = ge(e), r = t == Is ? e.constructor : void 0, n = r ? ee(r) : "";
  if (n)
    switch (n) {
      case Ls:
        return ir;
      case $s:
        return tr;
      case ys:
        return rr;
      case ws:
        return nr;
      case xs:
        return ar;
    }
  return t;
});
const or = J;
var Ms = 1, ur = "[object Arguments]", sr = "[object Array]", Ie = "[object Object]", Fs = Object.prototype, cr = Fs.hasOwnProperty;
function Us(e, t, r, n, a, i) {
  var o = k(e), u = k(t), s = o ? sr : or(e), c = u ? sr : or(t);
  s = s == ur ? Ie : s, c = c == ur ? Ie : c;
  var l = s == Ie, d = c == Ie, g = s == c;
  if (g && ot(e)) {
    if (!ot(t))
      return !1;
    o = !0, l = !1;
  }
  if (g && !l)
    return i || (i = new G()), o || zr(e) ? Yr(e, t, r, n, a, i) : gs(e, t, s, r, n, a, i);
  if (!(r & Ms)) {
    var f = l && cr.call(e, "__wrapped__"), v = d && cr.call(t, "__wrapped__");
    if (f || v) {
      var C = f ? e.value() : e, E = v ? t.value() : t;
      return i || (i = new G()), a(C, E, r, n, i);
    }
  }
  return g ? (i || (i = new G()), As(e, t, r, n, a, i)) : !1;
}
function Et(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !ce(e) && !ce(t) ? e !== e && t !== t : Us(e, t, r, n, Et, a);
}
var Ds = 1, Bs = 2;
function ks(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var u = r[a];
    if (o && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    u = r[a];
    var s = u[0], c = e[s], l = u[1];
    if (o && u[2]) {
      if (c === void 0 && !(s in e))
        return !1;
    } else {
      var d = new G();
      if (n)
        var g = n(c, l, s, e, t, d);
      if (!(g === void 0 ? Et(l, c, Ds | Bs, n, d) : g))
        return !1;
    }
  }
  return !0;
}
function qr(e) {
  return e === e && !le(e);
}
function Hs(e) {
  for (var t = St(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, qr(a)];
  }
  return t;
}
function Zr(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function Gs(e) {
  var t = Hs(e);
  return t.length == 1 && t[0][2] ? Zr(t[0][0], t[0][1]) : function(r) {
    return r === e || ks(r, e, t);
  };
}
var zs = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, js = /^\w*$/;
function bt(e, t) {
  if (k(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || De(e) ? !0 : js.test(e) || !zs.test(e) || t != null && e in Object(t);
}
var Ws = "Expected a function";
function At(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Ws);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (At.Cache || j)(), r;
}
At.Cache = j;
var Vs = 500;
function Ys(e) {
  var t = At(e, function(n) {
    return r.size === Vs && r.clear(), n;
  }), r = t.cache;
  return t;
}
var qs = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Zs = /\\(\\)?/g, Ks = Ys(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(qs, function(r, n, a, i) {
    t.push(a ? i.replace(Zs, "$1") : n || r);
  }), t;
});
const Js = Ks;
function Kr(e, t) {
  return k(e) ? e : bt(e, t) ? [e] : Js(Pe(e));
}
var Xs = 1 / 0;
function He(e) {
  if (typeof e == "string" || De(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Xs ? "-0" : t;
}
function Jr(e, t) {
  t = Kr(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[He(t[r++])];
  return r && r == n ? e : void 0;
}
function Ge(e, t, r) {
  var n = e == null ? void 0 : Jr(e, t);
  return n === void 0 ? r : n;
}
function Qs(e, t) {
  return e != null && t in Object(e);
}
function ec(e, t, r) {
  t = Kr(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = He(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && Rt(a) && Hr(o, a) && (k(e) || Br(e)));
}
function tc(e, t) {
  return e != null && ec(e, t, Qs);
}
var rc = 1, nc = 2;
function ac(e, t) {
  return bt(e) && qr(t) ? Zr(He(e), t) : function(r) {
    var n = Ge(r, e);
    return n === void 0 && n === t ? tc(r, e) : Et(t, n, rc | nc);
  };
}
function ic(e) {
  return e;
}
function oc(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function uc(e) {
  return function(t) {
    return Jr(t, e);
  };
}
function sc(e) {
  return bt(e) ? oc(He(e)) : uc(e);
}
function cc(e) {
  return typeof e == "function" ? e : e == null ? ic : typeof e == "object" ? k(e) ? ac(e[0], e[1]) : Gs(e) : sc(e);
}
function te(e, t) {
  var r = k(e) ? Ur : Xo;
  return r(e, cc(t));
}
function lc(e, t, r, n) {
  var a = -1, i = e == null ? 0 : e.length;
  for (n && i && (r = e[++a]); ++a < i; )
    r = t(r, e[a], a, e);
  return r;
}
function fc(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var dc = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, gc = fc(dc);
const _c = gc;
var mc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, vc = "\\u0300-\\u036f", hc = "\\ufe20-\\ufe2f", pc = "\\u20d0-\\u20ff", Cc = vc + hc + pc, Rc = "[" + Cc + "]", Sc = RegExp(Rc, "g");
function Ec(e) {
  return e = Pe(e), e && e.replace(mc, _c).replace(Sc, "");
}
var bc = "['’]", Ac = RegExp(bc, "g");
function Pc(e) {
  return function(t) {
    return lc(it(Ec(t).replace(Ac, "")), e, "");
  };
}
var Oc = Pc(function(e, t, r) {
  return e + (r ? "-" : "") + t.toLowerCase();
});
const fe = Oc;
function Tc(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
function Nc(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : Tc(e, t, r);
}
var Ic = "\\ud800-\\udfff", Lc = "\\u0300-\\u036f", $c = "\\ufe20-\\ufe2f", yc = "\\u20d0-\\u20ff", wc = Lc + $c + yc, xc = "\\ufe0e\\ufe0f", Mc = "\\u200d", Fc = RegExp("[" + Mc + Ic + wc + xc + "]");
function Xr(e) {
  return Fc.test(e);
}
function Uc(e) {
  return e.split("");
}
var Qr = "\\ud800-\\udfff", Dc = "\\u0300-\\u036f", Bc = "\\ufe20-\\ufe2f", kc = "\\u20d0-\\u20ff", Hc = Dc + Bc + kc, Gc = "\\ufe0e\\ufe0f", zc = "[" + Qr + "]", ft = "[" + Hc + "]", dt = "\\ud83c[\\udffb-\\udfff]", jc = "(?:" + ft + "|" + dt + ")", en = "[^" + Qr + "]", tn = "(?:\\ud83c[\\udde6-\\uddff]){2}", rn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Wc = "\\u200d", nn = jc + "?", an = "[" + Gc + "]?", Vc = "(?:" + Wc + "(?:" + [en, tn, rn].join("|") + ")" + an + nn + ")*", Yc = an + nn + Vc, qc = "(?:" + [en + ft + "?", ft, tn, rn, zc].join("|") + ")", Zc = RegExp(dt + "(?=" + dt + ")|" + qc + Yc, "g");
function Kc(e) {
  return e.match(Zc) || [];
}
function Jc(e) {
  return Xr(e) ? Kc(e) : Uc(e);
}
function Xc(e) {
  return function(t) {
    t = Pe(t);
    var r = Xr(t) ? Jc(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? Nc(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var Qc = Xc("toUpperCase");
const el = Qc;
function gt(e) {
  return el(Pe(e).toLowerCase());
}
var ze = String.fromCharCode(8202), Oe = {
  CAD: "C$",
  USD: "$"
};
function tl(e) {
  return parseInt(e, 10);
}
function je(e) {
  var t = parseInt(e, 10), r = void 0, n = void 0;
  isNaN(t) && (t = 0);
  var a = Math.abs(t);
  return a >= 1e9 ? (r = parseInt(t / 1e8, 10) / 10, n = "B") : a >= 1e6 ? (r = parseInt(t / 1e5, 10) / 10, n = "M") : a >= 1e3 ? (r = parseInt(t / 100, 10) / 10, n = "K") : (r = parseInt(t, 10), n = ""), r >= 10 && (r = parseInt(r, 10)), r + n;
}
function on(e) {
  if (!e && e !== 0)
    return NaN;
  var t = "" + e, r = t.charAt(0) === "-", n = /(-?(?:(?:\d|\.)+))\s*([bmkt])?/i.exec(t.replace(/,/g, ""));
  if (!n)
    return NaN;
  var a = parseFloat(n[1]);
  if (isNaN(a))
    return NaN;
  r && a > 0 && (a *= -1);
  var i = n[2];
  switch (i) {
    case "T":
    case "t":
      return a * 1e12;
    case "B":
    case "b":
      return a * 1e9;
    case "M":
    case "m":
      return a * 1e6;
    case "K":
    case "k":
      return a * 1e3;
    default:
      return a;
  }
}
function rl(e, t, r) {
  var n = document.getElementsByClassName(e)[0], a = on(n.get("value"));
  isNaN(a) || a >= 0 && (r ? n.set("value", ln(a)) : n.set("value", q(a)), t && sn(e, t));
}
function nl(e) {
  var t = document.getElementsByClassName(e)[0], r = t.get("value");
  t.set("value", cn(r));
}
function un(e) {
  return e && e.length === 6 ? e.slice(0, 3) + " " + e.slice(3) : e;
}
function al(e, t) {
  var r = e.value, n = 0, a = void 0;
  document.selection ? (e.focus(), a = document.selection.createRange(), a.moveStart("character", -r.length), n = a.text.length) : (e.selectionStart || e.selectionStart === 0) && (n = e.selectionStart), t && r.charAt(0) !== "$" && (n += 1);
  for (var i = 0; i < n; i += 1)
    r.charAt(i) === "," && (n -= 1);
  return n;
}
function sn(e, t) {
  for (var r = 0; r < t; r += 1)
    e.value.charAt(r) === "," && (t += 1);
  if (document.selection) {
    e.focus();
    var n = document.selection.createRange();
    n.moveStart("character", -e.value.length), n.moveStart("character", t);
    var a = e.value.length - t;
    n.moveEnd("character", -a), n.select();
  } else
    (e.selectionStart || e.selectionStart === 0) && (e.selectionStart = t, e.selectionEnd = t, e.focus());
}
function il(e, t) {
  var r = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], n = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], a = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], i = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  function o(s) {
    return (String(s).length === 1 ? "0" : "") + s;
  }
  var u = e.matches || {
    d: function() {
      return o(e.getDate());
    },
    D: function() {
      return "" + e.getDate();
    },
    l: function() {
      return r[e.getDay()];
    },
    L: function() {
      return n[e.getDay()];
    },
    m: function() {
      return o(e.getMonth() + 1);
    },
    M: function() {
      return e.getMonth() + 1;
    },
    f: function() {
      return a[e.getMonth()];
    },
    F: function() {
      return i[e.getMonth()];
    },
    y: function() {
      return ("" + e.getFullYear()).slice(2, 4);
    },
    Y: function() {
      return "" + e.getFullYear();
    },
    g: function() {
      return o(e.getHours() % 12);
    },
    G: function() {
      return "" + e.getHours() % 12;
    },
    i: function() {
      return o(e.getMinutes());
    },
    s: function() {
      return o(e.getSeconds());
    },
    t: function() {
      return e.getHours() > 11 ? "pm" : "am";
    }
  };
  return t.replace(/[dDlLmMfFyYgGist]/g, function(s) {
    return u[s]();
  });
}
function q(e) {
  if (isNaN(e))
    return e;
  for (var t = /(\d+)(\d{3})/, r = ("" + e).split("."), n = r[0], a = r.length > 1 ? "." + r[1] : ""; t.test(n); )
    n = n.replace(t, "$1,$2");
  return n + a;
}
function cn(e) {
  var t = /^(\d{3})$/, r = /^(\(\d{3}\) \d{3})(-*)$/, n = /^(\(\d{3}\) \d{3}-\d{4})(\d+)$/, a = /^(\(\d{3}\) \d{3}-\d{4})(\s+)$/, i = /^(\d{3})(\d{3})(\d{4})$/, o = /^(\d{3})(\d{3})(\d{4})(\d+)$/, u = "" + e;
  return t.test(u) ? u = u.replace(t, "($1) ") : r.test(u) ? u = u.replace(r, "$1-") : n.test(u) ? u = u.replace(n, "$1 x$2") : a.test(u) ? u = u.replace(a, "$1 x") : i.test(u) ? u = u.replace(i, "($1) $2-$3") : o.test(u) && (u = u.replace(o, "($1) $2-$3 x$4")), u;
}
function We(e, t) {
  return isNaN(e) ? e : parseFloat(e).toFixed(t || 2);
}
function Pt(e, t) {
  if (isNaN(e))
    return e;
  var r = t || 2, n = We(e, r), a = Math.pow(r, 10);
  return n * a / a;
}
function ol(e, t) {
  return isNaN(e) ? e : Pt(e, t) + ze + "%";
}
function ul(e, t) {
  return isNaN(e) ? e : We(e, t) + ze + "%";
}
function ln(e, t) {
  return Ve(e, "$", t);
}
function Ve(e, t, r) {
  if (isNaN(e))
    return e;
  var n = void 0, a = t || "$", i = Oe[a] || a;
  return r ? n = q(fn(e)) : n = q(Math.round(e)), n.charAt(0) === "-" ? "-" + i + n.slice(1) : "" + i + n;
}
function sl(e, t) {
  var r = t || "$", n = Oe[r] || r;
  return isNaN(e) ? e : "" + n + je(e);
}
function cl(e) {
  return isNaN(e) ? e : q(Pt(e));
}
function ll(e) {
  return isNaN(e) ? e : q(We(e));
}
function fl(e) {
  return isNaN(e) ? e : q(parseInt(e, 10));
}
function dl(e) {
  return isNaN(e) ? e : "$" + ze + q(parseInt(e, 10));
}
function gl(e) {
  return isNaN(e) ? e : je(e);
}
function fn(e) {
  return isNaN(e) ? e : parseFloat(e).toFixed(2);
}
function _l(e) {
  return isNaN(e) ? e : "$" + ze + je(e);
}
function ml(e) {
  return Math.round(((/* @__PURE__ */ new Date()).getTime() - e) / (1e3 * 60 * 60 * 24));
}
function vl(e, t) {
  var r = Number(e.replace(/[^0-9.]+/g, ""));
  return t === !0 && (r = parseInt(r, 10)), r;
}
function hl(e) {
  var t = Math.floor(e / 12), r = e % 12, n = [];
  return t === 1 ? n.push(t, " year") : t > 1 && n.push(t, " years"), t > 0 && r > 0 && n.push(", "), r === 1 ? n.push(r, " month") : (r > 1 || t === 0) && n.push(r, " months"), n.join("");
}
function pl(e) {
  if (typeof e != "number")
    return "";
  var t = Math.floor(e / 1e3 / 60), r = Math.floor(t / 60), n = Math.floor(r / 24);
  return n > 0 ? n === 1 ? n + " day" : n + " days" : r > 0 ? r === 1 ? r + " hr" : r + " hrs" : t < 1 ? "Less than 1 min" : t + " min";
}
const Cl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENCY_SYMBOL_MAP: Oe,
  abbr: je,
  comma: q,
  currencyToNum: vl,
  dollar: ln,
  fixedComma: ll,
  fixedFloat: We,
  fixedPercent: ul,
  formatDate: il,
  formatNumberField: rl,
  formatPhoneNumberField: nl,
  formatZipcode: un,
  fromString: on,
  getCaretPosition: al,
  getDaysOn: ml,
  largeDollar: _l,
  largeMoney: sl,
  largeNumber: gl,
  millisecondsToMinutesHoursDays: pl,
  money: Ve,
  monthsToYears: hl,
  phoneNumber: cn,
  roundComma: cl,
  roundDollar: dl,
  roundFloat: Pt,
  roundPercent: ol,
  setCaretPosition: sn,
  toInt: tl,
  twoPointFloat: fn,
  wholeComma: fl
}, Symbol.toStringTag, { value: "Module" }));
var U = "--", Rl = 999499, Sl = /^Homes in (.*)$/, El = /^Homes in (.*)$/, bl = /(.*)_rid(.*)/, dn = 10890, gn = 229568411e-13, _n = /* @__PURE__ */ new Set(["Zillow", "Zestimate", "zillow", "zestimate"]), _t = "Contact manager", Al = [{
  matcher: /Make me move/gi,
  // note case-insensitive matcher
  replacement: "Make Me Move"
}], mt = {
  virtualTour: "Virtual tour",
  leaseAmount: "Lease amount",
  annualTaxAmount: "Annual tax amount",
  hoaFee1: "HOA fee",
  hoaFee2: "Second HOA fee"
}, D = function(t, r) {
  return r === void 0 && (r = null), function(n) {
    return n ? t(n) : r;
  };
};
function re(e, t, r) {
  return e === 1 ? t : r || t + "s";
}
var Pl = ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"], Ol = ["sw", "nw", "se", "ne"], mn = function e(t) {
  return t.startsWith("(") ? "(" + e(t.substring(1)) : Number.isNaN(Number(t)) ? _n.has(t) ? gt(t) : Pl.indexOf(t.toLowerCase()) >= 0 || Ol.includes(t.toLowerCase()) ? t.toUpperCase() : gt(t) : t;
}, Ye = function(t) {
  return t ? t.trim().split(" ").map(mn).join(" ") : "";
}, Tl = function(t) {
  var r = !1;
  if (!t || t && typeof t != "string")
    return "";
  var n = function(o) {
    return _n.has(o) ? gt(o) : r ? o.toLowerCase() : !r && !Number.isNaN(Number(o)) || r ? o : (r = !0, mn(o));
  }, a = t.trim().split(" ").map(n).join(" ");
  return Al.forEach(function(i) {
    var o = i.matcher, u = i.replacement;
    a = a.replace(o, u);
  }), a;
}, vn = function(t, r) {
  return t === void 0 && (t = "$"), D(function(n) {
    return Ve(n, t, r);
  }, "" + (Oe[t] || t) + U);
}, Nl = vn("$"), Il = D(function(e) {
  return e + " " + re(e, "photo");
}, ""), hn = D(function(e) {
  return e + " " + re(e, "bed");
}, U + " beds"), pn = D(function(e) {
  return e + " " + re(e, "bd");
}, U + " bds"), Ll = D(function(e) {
  return e + " " + re(e, "bath");
}, U + " baths"), $l = D(function(e) {
  return e + " ba";
}, U + " ba"), yl = D(function(e) {
  return e.toLocaleString() + " sqft";
}, U + " sqft"), Cn = D(function(e) {
  return Ye(e);
}, U), Ot = D(function(e) {
  return Ye(e);
}, U), qe = D(function(e) {
  return e.toUpperCase();
}, U), Ze = D(function(e) {
  return un(e);
}, U);
function wl(e) {
  return e === 0 ? "Studio" : pn(e);
}
function xl(e) {
  return e === 0 ? "Studio" : hn(e);
}
var Ml = function(t) {
  var r = U, n = "sqft";
  if (t && typeof t == "number" && t > 0)
    if (t >= dn) {
      var a = t * gn, i = Math.round(a * 100) / 100;
      r = i.toLocaleString(), n = re(i, "acre");
    } else
      r = t.toLocaleString();
  return {
    value: r,
    unit: n
  };
}, Fl = function(t) {
  var r = U + " sqft";
  if (t && t > 0)
    if (t >= dn) {
      var n = t * gn, a = Math.round(n * 100) / 100;
      r = a.toLocaleString() + " " + re(a, "acre");
    } else
      r = t.toLocaleString() + " sqft";
  return r;
}, Ul = function(t, r, n) {
  return t ? t.toLocaleString() + " " + (r || "sqft") : n;
}, Te = function(t, r) {
  var n = "";
  return t && r ? n = "" + t + r + "_rid/" : t ? n = t : r && (n = "/" + r + "_rid/"), n;
}, Dl = function(t, r, n, a) {
  return Cn(t) + ", " + Ot(r) + ", " + qe(n) + " " + Ze(a);
}, Bl = function(t, r, n) {
  return Ot(t) + ", " + qe(r) + " " + Ze(n);
}, kl = function(t, r) {
  return qe(t) + " " + Ze(r);
}, Hl = function(t, r) {
  var n = t ? t.trim() : null, a = n ? "/" + n.toLowerCase() + "/" : null;
  return Te(a, r);
}, Rn = function(t, r, n) {
  var a = te([fe(t && t.toLowerCase()), r && r.trim()]).join("-").toLowerCase(), i = a ? "/" + a + "/" : null;
  return Te(i, n);
}, Gl = function(t, r, n) {
  var a = te([r && r.trim(), t ? t.toString().replace(/ /g, "").trim() : null]).join("-").toLowerCase(), i = a ? "/" + a + "/" : null;
  return Te(i, n);
}, zl = function(t, r, n) {
  var a = te([fe(t && t.toLowerCase()), r && r.trim(), n ? n.toString().replace(/ /g, "").trim() : null]).join("-").toLowerCase();
  return a && "/" + a + "/";
}, jl = function(t, r, n) {
  var a = t, i = r;
  if (!n)
    return null;
  i || (i = "Error Subdivision Name Unavailable"), a || (a = ""), String.prototype.normalize || (String.prototype.normalize = function(u) {
    var s = "ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž", c = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz", l = this.split("");
    return l.forEach(function(d, g) {
      var f = s.indexOf(d);
      f !== -1 && (l[g] = c[f]);
    }), l.join("");
  }), a = a.normalize("NFD").replace(/[^a-zA-Z0-9 ]/g, ""), i = i.normalize("NFD").replace(/[^a-zA-Z0-9 ]/g, "");
  var o = te(it(a && a.toLowerCase()).concat(it(i && i.toLowerCase())), function(u) {
    return u !== "the";
  }).join("-");
  return "/community/" + o + "/" + n + "_plid/";
}, Wl = function(t, r, n, a, i) {
  var o = te([fe(t && t.toLowerCase()), fe(r && r.toLowerCase()), n && n.trim(), a ? a.toString().trim() : null]).join("-").toLowerCase(), u = o ? "/" + o + "/" : null;
  return Te(u, i);
}, Vl = function(t, r) {
  var n = te([r && r.trim(), fe(t && t.toLowerCase())]).join("/").toLowerCase();
  return n ? "/mortgage-rates/" + n + "/" : "/mortgage-rates/";
}, Yl = function(t, r) {
  var n = te([r && r.trim(), fe(t && t.toLowerCase())]).join("/").toLowerCase();
  return n ? "/refinance/" + n + "/" : "/refinance/";
}, ql = function(t, r) {
  var n = Rn(t, r);
  return n ? "/directory" + n + "real-estate-agents/" : "/directory/real-estate-agents/";
}, Zl = function(t) {
  return t === "FOR_RENT" ? "/homes/for_rent" : "";
}, Kl = function(t, r) {
  if (t === "FOR_RENT") {
    if (r === "SINGLE_FAMILY")
      return "/rent-houses/";
    if (r === "APARTMENT" || r === "CONDO" || r === "MULTI_FAMILY")
      return "/apartments/";
    if (r === "TOWNHOUSE")
      return "/rent-townhomes/";
  }
  return "";
}, Jl = function(t, r) {
  r === void 0 && (r = "$");
  var n, a, i = parseInt(t, 10);
  return Number.isNaN(i) || i < 0 ? null : (i >= 1e9 ? (n = Math.round(i / 1e8) / 10, a = "B") : i >= 1e6 ? (n = Math.round(i / 1e5) / 10, a = "M") : i > Rl && i < 1e6 ? (n = 1, a = "M") : i >= 1e3 ? (n = Math.round(i / 100) / 10, a = "K") : (n = Math.round(i), a = ""), "" + (Oe[r] || r) + n + a);
}, Sn = function() {
  if (typeof window > "u")
    return !1;
  var t = Ge(window, "navigator.userAgent", "");
  return /(iPad|iPhone|iPod)/.test(t);
}, Xl = function() {
  if (Sn()) {
    var t = Ge(window, "navigator.userAgent", ""), r = t.match(/OS (\d+)_?/);
    return parseInt(r[1], 10);
  }
  return null;
}, Ql = function(t, r) {
  var n = null;
  if (typeof window < "u") {
    var a = "?";
    if (Sn()) {
      var i = Xl();
      i < 8 ? a = ";" : a = "&";
    }
    var o = window.location.protocol + "//" + window.location.hostname, u = r ? "" + o + r : window.location.href, s = t + " " + u + "?utm_source=txtshare";
    n = "sms:" + a + "body=" + encodeURIComponent(s);
  }
  return n;
}, ef = function(t) {
  var r = Ge(t, "citySearchUrl.text", null), n = null;
  if (r) {
    var a = Sl.exec(r);
    a && a[1] && (n = a[1]);
  }
  return !n && t && t.city && (n = Ye(t.city)), n;
}, tf = function(t) {
  var r = "", n = El.exec(t);
  return n && n[1] ? (r = n[1], r) : null;
}, rf = function(t) {
  var r = !1;
  if (t) {
    var n = bl.exec(t);
    n && n[1] && (r = !0);
  }
  return r;
}, En = function(t) {
  return String.prototype.normalize ? t.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : t;
}, nf = function(t) {
  return En(t.toLowerCase()).trim().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").replace(/-$/, "").replace(/^-/, "");
}, af = function(t) {
  return t && !t.startsWith("http://") && !t.startsWith("https://") && !t.startsWith("//");
}, bn = function(t) {
  return af(t) ? "//" + t : t;
}, of = function(t) {
  var r = t.factLabel, n = t.factValue, a = t.currency, i = t.isForRent, o = t.trackEventConfig, u = o === void 0 ? {} : o;
  return n == null ? null : typeof n == "boolean" ? n ? "Yes" : "No" : Array.isArray(n) ? i && n.includes("None") ? _t : n.join(", ") : i && /None/i.test(n) ? _t : r === mt.virtualTour ? /* @__PURE__ */ _.createElement("a", {
    href: bn(n),
    target: "_blank",
    rel: "nofollow noopener noreferrer",
    onClick: u.VIRTUAL_TOUR
  }, "View virtual tour") : Object.values(mt).includes(r) ? Ve(n, a) : n;
}, me = function(t, r) {
  return t === 1 ? t + " " + r + " space" : t > 1 ? t + " " + r + " spaces" : r;
}, uf = function(t) {
  return !t || t.length === 0 ? null : t.join(", ");
}, sf = function(t) {
  var r = t.factLabel, n = t.parkingData, a = n.hasCarport, i = n.carportSpaces, o = n.coveredSpaces, u = n.parking;
  if (!a)
    return null;
  var s = i || o || u, c = me(s, "Carport");
  return {
    factLabel: r,
    factValue: c
  };
}, cf = function(t) {
  var r = t.factLabel, n = t.parkingData.parking;
  if (!n)
    return null;
  var a = me(n, "Parking");
  return {
    factLabel: r,
    factValue: a
  };
}, lf = function(t) {
  var r = t.factLabel, n = t.parkingData, a = n.hasOpenParking, i = n.openParkingSpaces, o = n.parking;
  if (!a)
    return null;
  var u = i || o, s = me(u, "Open Parking");
  return {
    factLabel: r,
    factValue: s
  };
}, ff = function(t) {
  var r = t.factLabel;
  return {
    factLabel: r,
    factValue: "No Data"
  };
}, An = function(t) {
  var r = t.factLabel, n = t.parkingData, a = n.hasGarage, i = n.garageSpaces, o = n.coveredSpaces, u = n.parking;
  if (!a)
    return null;
  var s = i || o || u, c = me(s, "Garage");
  return {
    factLabel: r,
    factValue: c
  };
}, Pn = function(t) {
  var r = t.factLabel, n = t.parkingData, a = n.hasAttachedGarage, i = n.garageSpaces, o = n.coveredSpaces, u = n.parking;
  if (!a)
    return null;
  var s = i || o || u, c = me(s, "Attached Garage");
  return {
    factLabel: r,
    factValue: c
  };
}, On = function(t) {
  var r = t.factLabel, n = t.parkingData.coveredSpaces;
  if (!n)
    return null;
  var a = me(n, "Covered Parking");
  return {
    factLabel: r,
    factValue: a
  };
}, Tn = function(t) {
  var r = t.factLabel, n = t.parkingData.parkingFeatures;
  if (!n)
    return null;
  var a = uf(n);
  return {
    factLabel: r,
    factValue: a
  };
}, df = function(t) {
  var r = t.factLabel, n = t.data, a = {
    hasAttachedGarage: n.hasAttachedGarage,
    hasGarage: n.hasGarage,
    hasCarport: n.hasCarport,
    hasOpenParking: n.hasOpenParking,
    garageSpaces: n.garageSpaces,
    coveredSpaces: n.coveredSpaces,
    carportSpaces: n.carportSpaces,
    parking: n.parking,
    openParkingSpaces: n.openParkingSpaces,
    parkingFeatures: n.parkingFeatures
  };
  return Pn({
    factLabel: r,
    parkingData: a
  }) || An({
    factLabel: r,
    parkingData: a
  }) || sf({
    factLabel: r,
    parkingData: a
  }) || On({
    factLabel: r,
    parkingData: a
  }) || lf({
    factLabel: r,
    parkingData: a
  }) || cf({
    factLabel: r,
    parkingData: a
  }) || Tn({
    factLabel: r,
    parkingData: a
  }) || ff({
    factLabel: r
  });
};
const gf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CONTACT_MANAGER_STRING: _t,
  RESO_FACT_LABELS: mt,
  atAGlanceFactsParking: df,
  attachedGarageParkingFact: Pn,
  ba: $l,
  baths: Ll,
  bds: pn,
  bdsWithStudio: wl,
  beds: hn,
  bedsWithStudio: xl,
  capitalize: Ye,
  capitalizeFirst: Tl,
  cityFormat: Ot,
  cityLink: Rn,
  cityStateZip: Bl,
  cityStateZipLink: zl,
  communityLink: jl,
  constructVirtualTourHref: bn,
  coveredParkingFact: On,
  doesUrlContainRegionId: rf,
  extractAndFormatCityName: ef,
  formRegionIdLink: Te,
  formatBoroughName: tf,
  formatCurrency: Jl,
  formatFactValue: of,
  formatLotAreaOrLivingAreaWithFallback: Ul,
  formatLotSize: Fl,
  garageParkingFact: An,
  generateTextMessageHref: Ql,
  getSlug: nf,
  getUrlPrefixForHomeStatus: Zl,
  getUrlSuffixForHomeStatus: Kl,
  livingArea: yl,
  livingAreaWithSeparateValueUnit: Ml,
  mortgageRatesLink: Vl,
  neighborhoodLink: Wl,
  parkingFeaturesFact: Tn,
  photos: Il,
  pluralize: re,
  price: Nl,
  priceWithCurrency: vn,
  realEstateAgentsLink: ql,
  refinanceLink: Yl,
  stateFormat: qe,
  stateLink: Hl,
  stateZip: kl,
  streetCityStateZip: Dl,
  streetFormat: Cn,
  stripAccents: En,
  zipLink: Gl,
  zipcodeFormat: Ze
}, Symbol.toStringTag, { value: "Module" })), Nn = /* @__PURE__ */ de(gf), _f = /* @__PURE__ */ de(Cl);
var O = {};
Object.defineProperty(O, "__esModule", {
  value: !0
});
var In = O.PRICE_INCREASE_STRING = yn = O.PRICE_CUT_STRING = $n = O.PRICE_CHANGE_STRING = Mn = O.NO_PRICE_PROPERTY_MAP_PILL_LIST_CARD_LABEL = xn = O.NO_PRICE_PROPERTY_LIST_CARD_LABEL = wn = O.EMPTY_VALUE_STRING = Ln = O.DEFAULT_PRICE_STRING = Fn = O.CONTACT_LANDLORD_STRING = void 0;
const mf = "$--";
var Ln = O.DEFAULT_PRICE_STRING = mf;
const vf = "Price Change";
var $n = O.PRICE_CHANGE_STRING = vf;
const hf = "Price cut:";
var yn = O.PRICE_CUT_STRING = hf;
const pf = "Price increase:";
In = O.PRICE_INCREASE_STRING = pf;
const Cf = "--";
var wn = O.EMPTY_VALUE_STRING = Cf;
const Rf = "Contact for Pricing";
var xn = O.NO_PRICE_PROPERTY_LIST_CARD_LABEL = Rf;
const Sf = "Contact for Price";
var Mn = O.NO_PRICE_PROPERTY_MAP_PILL_LIST_CARD_LABEL = Sf;
const Ef = "Contact Landlord";
var Fn = O.CONTACT_LANDLORD_STRING = Ef;
const bf = /* @__PURE__ */ Ue({
  __proto__: null,
  get CONTACT_LANDLORD_STRING() {
    return Fn;
  },
  get DEFAULT_PRICE_STRING() {
    return Ln;
  },
  get EMPTY_VALUE_STRING() {
    return wn;
  },
  get NO_PRICE_PROPERTY_LIST_CARD_LABEL() {
    return xn;
  },
  get NO_PRICE_PROPERTY_MAP_PILL_LIST_CARD_LABEL() {
    return Mn;
  },
  get PRICE_CHANGE_STRING() {
    return $n;
  },
  get PRICE_CUT_STRING() {
    return yn;
  },
  get PRICE_INCREASE_STRING() {
    return In;
  },
  default: O
}, [O]), Tt = /* @__PURE__ */ de(bf);
var b = {};
Object.defineProperty(b, "__esModule", {
  value: !0
});
var Un = b.removeTrailingPlus = kn = b.getStandardPrice = Hn = b.getRoomForRentUnit = Zn = b.getPriceStringForBuildingUnit = Dn = b.getMonthlyCost = zn = b.getInitialBuildingUnitPrice = Vn = b.getFormattedPrice = Wn = b.getBuildingUnitPriceRange = qn = b.getBuildingUnitPrice = void 0, xe = Nn, V = Tt;
const Af = (e, t) => e ? (0, xe.formatCurrency)(e, t) : V.DEFAULT_PRICE_STRING;
var Dn = b.getMonthlyCost = Af;
const Bn = ({
  countryCurrency: e,
  festimate: t,
  paymentPeriod: r = "",
  price: n,
  shouldShowZestimateAsPrice: a,
  soldPrice: i,
  zestimate: o
}) => {
  let u;
  const s = /.*[1-9].*/;
  return t ? u = t : i ? u = i : n && s.test(n.toString()) ? u = typeof n == "string" ? n : `${(0, xe.priceWithCurrency)(e)(n)}${r ? `/${r}` : ""}` : a && (u = (0, xe.formatCurrency)(o, e)), u ? t || !(n && s.test(n.toString())) && a ? `Est. ${u}` : u : V.DEFAULT_PRICE_STRING;
};
var kn = b.getStandardPrice = Bn;
const Nt = (e) => e.filter((r) => r.roomForRent)[0];
var Hn = b.getRoomForRentUnit = Nt;
const Gn = ({
  units: e,
  isNoPriceRentalPropertyTest: t
}) => {
  if (Array.isArray(e) && e !== null && e !== void 0 && e.length) {
    const r = Nt(e);
    if (r)
      return `${Ae(r, t)} Room`;
    const [n] = e;
    return `${Ae(n, t)}${n != null && n.beds ? ` ${(0, xe.bdsWithStudio)(parseInt(n.beds, 10))}` : ""}`;
  }
  return null;
};
var zn = b.getInitialBuildingUnitPrice = Gn;
const jn = ({
  units: e,
  isNoPriceRentalPropertyTest: t
}) => {
  if (Array.isArray(e) && e !== null && e !== void 0 && e.length) {
    var r;
    const [n] = e, a = (r = Nt(e)) !== null && r !== void 0 ? r : n, i = e.filter((u) => !u.roomForRent).slice(-1)[0];
    return `${vt(Ae(a, t))} - ${vt(Ae(i, t))}`;
  }
  return null;
};
var Wn = b.getBuildingUnitPriceRange = jn;
const Pf = (e, t = !1) => e ? e.isNoPriceRentalPropertyTest && e.price === V.CONTACT_LANDLORD_STRING ? e.isForMiniBubble ? V.NO_PRICE_PROPERTY_MAP_PILL_LIST_CARD_LABEL : V.NO_PRICE_PROPERTY_LIST_CARD_LABEL : e.isBuilding && !e.isMapCard ? Yn(e, t) : Bn(e) : null;
var Vn = b.getFormattedPrice = Pf;
const Yn = (e, t) => {
  var r;
  return t && Array.isArray(e.units) && ((r = e.units) === null || r === void 0 ? void 0 : r.length) > 1 ? jn(e) : Gn(e);
};
var qn = b.getBuildingUnitPrice = Yn;
const vt = (e) => e == null ? null : e.endsWith("+") ? e.slice(0, -1) : e;
Un = b.removeTrailingPlus = vt;
const Ae = (e, t) => e != null && e.price ? e.price === V.CONTACT_LANDLORD_STRING && t ? V.NO_PRICE_PROPERTY_LIST_CARD_LABEL : e.price : V.DEFAULT_PRICE_STRING;
var Zn = b.getPriceStringForBuildingUnit = Ae;
const Of = /* @__PURE__ */ Ue({
  __proto__: null,
  default: b,
  get getBuildingUnitPrice() {
    return qn;
  },
  get getBuildingUnitPriceRange() {
    return Wn;
  },
  get getFormattedPrice() {
    return Vn;
  },
  get getInitialBuildingUnitPrice() {
    return zn;
  },
  get getMonthlyCost() {
    return Dn;
  },
  get getPriceStringForBuildingUnit() {
    return Zn;
  },
  get getRoomForRentUnit() {
    return Hn;
  },
  get getStandardPrice() {
    return kn;
  },
  get removeTrailingPlus() {
    return Un;
  }
}, [b]), Kn = /* @__PURE__ */ de(Of);
Object.defineProperty(P, "__esModule", {
  value: !0
});
var Jn = P.pluralize = ua = P.getRoomInfo = ta = P.getFormattedSqft = ea = P.getFormattedBedsBathsSqft = na = P.getFormattedAddress = aa = P.getAdditionalInfo = ra = P.getAdditionalBuildingUnits = ia = P.formatDetailString = void 0, Qe = If(_), Xn = Nn, Tf = _f, It = Tt, Nf = Kn, et = "/builds/zillow/discover-experience/property-card-formatters/src/formatters/formatters.tsx";
function Qn(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Qn = function(n) {
    return n ? r : t;
  })(e);
}
function If(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = Qn(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
const Lf = ({
  addressState: e,
  area: t,
  baths: r,
  beds: n,
  lotAreaString: a,
  lotArea: i,
  buildingId: o,
  minBeds: u,
  minBaths: s,
  minArea: c
}) => {
  const l = typeof e == "string" && e.toUpperCase() === "ON";
  if (a)
    return [{
      value: `${ht(a)} lot`
    }];
  if (typeof i < "u")
    return i || !l ? [{
      value: `${(0, Xn.formatLotSize)(i)} lot`
    }] : [];
  const d = [], g = n === 0;
  return d.push({
    value: g ? "Studio" : n ? n.toString() : $e(o, u),
    label: g ? "" : /* @__PURE__ */ Qe.createElement("abbr", {
      __self: void 0,
      __source: {
        fileName: et,
        lineNumber: 72,
        columnNumber: 7
      }
    }, `${n && n === 1 ? "bd" : "bds"}`)
  }), d.push({
    value: r ? r.toString() : $e(o, s),
    label: /* @__PURE__ */ Qe.createElement("abbr", {
      __self: void 0,
      __source: {
        fileName: et,
        lineNumber: 77,
        columnNumber: 12
      }
    }, "ba")
  }), (t || !l) && d.push({
    value: t ? ht(t.toString()) : $e(o, c, !0),
    label: /* @__PURE__ */ Qe.createElement("abbr", {
      __self: void 0,
      __source: {
        fileName: et,
        lineNumber: 86,
        columnNumber: 14
      }
    }, "sqft")
  }), d;
};
var ea = P.getFormattedBedsBathsSqft = Lf;
const ht = (e) => e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
var ta = P.getFormattedSqft = ht;
const $f = ({
  units: e,
  isNoPriceRentalPropertyTest: t
}) => {
  if (!e || e.length <= 1)
    return [];
  const n = e.some((i) => i.roomForRent) ? 0 : 1;
  return e.slice(n).filter((i) => !i.roomForRent).map((i) => {
    const {
      beds: o
    } = i;
    return {
      value: (0, Nf.getPriceStringForBuildingUnit)(i, t),
      label: o ? (0, Xn.bdsWithStudio)(parseInt(o, 10)) : `${It.EMPTY_VALUE_STRING} bds`
    };
  });
};
var ra = P.getAdditionalBuildingUnits = $f;
const yf = ({
  address: e,
  buildingName: t,
  isBuilding: r
}) => {
  const n = e || "";
  return r && t ? `${t} | ${n}` : n;
};
var na = P.getFormattedAddress = yf;
const lr = (e, t) => e && t ? `${e.toUpperCase()} (${t})` : `${e.toUpperCase()}`, fr = (e, t) => e && t ? `${e} (${t})` : e, wf = ({
  brokerName: e,
  brokerPhone: t,
  builderName: r,
  info1String: n,
  info6String: a,
  info7String: i,
  soldByOfficeName: o,
  isCdpResult: u,
  listingType: s
}) => {
  if (u && r && s === "NEW_CONSTRUCTION")
    return `New construction community by ${r}`;
  const c = [];
  return n && c.push(n), r && c.push(r), e && o ? (c.push(`Listed By: ${lr(e, t)}`), a && c.push(fr(a, i)), c.push(`Sold By: ${o.toUpperCase()}`)) : e && c.push(lr(e, t)), !o && a && c.push(fr(a, i)), c.length ? c.join(", ") : null;
};
var aa = P.getAdditionalInfo = wf;
const $e = (e, t, r = !1) => t || t === 0 ? r ? `${(0, Tf.wholeComma)(t)}${e ? "+" : ""}` : `${t}${e ? "+" : ""}` : It.EMPTY_VALUE_STRING;
var ia = P.formatDetailString = $e;
const xf = (e) => {
  switch (e) {
    case "Square Feet":
      return "sqft";
    default:
      return It.EMPTY_VALUE_STRING;
  }
}, oa = (e, t, r = "s") => `${e} ${t}${e !== 1 ? r : ""}`;
Jn = P.pluralize = oa;
const Mf = ({
  hdpData: e,
  rooms: t
}) => {
  var r;
  const n = e == null || (r = e.homeInfo) === null || r === void 0 ? void 0 : r.rentalR4RRoommateCount;
  if (t && t.length == 1) {
    const a = Math.round(t[0].roomArea), i = t[0].roomAreaUnits ? xf(t[0].roomAreaUnits) : null;
    return n > 0 && a > 0 && i ? `${a} ${i} room, ${oa(n, "housemate")}` : null;
  }
  return null;
};
var ua = P.getRoomInfo = Mf;
const Ff = /* @__PURE__ */ Ue({
  __proto__: null,
  default: P,
  get formatDetailString() {
    return ia;
  },
  get getAdditionalBuildingUnits() {
    return ra;
  },
  get getAdditionalInfo() {
    return aa;
  },
  get getFormattedAddress() {
    return na;
  },
  get getFormattedBedsBathsSqft() {
    return ea;
  },
  get getFormattedSqft() {
    return ta;
  },
  get getRoomInfo() {
    return ua;
  },
  get pluralize() {
    return Jn;
  }
}, [P]), sa = /* @__PURE__ */ de(Ff);
var Q = {};
Object.defineProperty(Q, "__esModule", {
  value: !0
});
var ca = Q.getRentalPropertyCardBadge = da = Q.getPropertyCardBadge = void 0, x = Df(_), M = Oa, tt = Tt, Uf = sa, F = "/builds/zillow/discover-experience/property-card-formatters/src/formatters/badges.tsx";
function la(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (la = function(n) {
    return n ? r : t;
  })(e);
}
function Df(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = la(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
const rt = ({
  isIncrease: e,
  text: t,
  isNewNotification: r
}) => {
  switch (e) {
    case !0:
      return /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
        appearance: r ? "notification" : "default",
        key: t,
        __self: void 0,
        __source: {
          fileName: F,
          lineNumber: 36,
          columnNumber: 9
        }
      }, tt.PRICE_INCREASE_STRING, " ", t);
    case !1:
      return /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
        appearance: r ? "notification" : "default",
        __self: void 0,
        __source: {
          fileName: F,
          lineNumber: 45,
          columnNumber: 9
        }
      }, tt.PRICE_CUT_STRING, " ", t);
    default:
      return /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
        appearance: r ? "notification" : "default",
        __self: void 0,
        __source: {
          fileName: F,
          lineNumber: 53,
          columnNumber: 9
        }
      }, tt.PRICE_CHANGE_STRING, " ", t);
  }
}, Bf = (e) => /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
  key: e,
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 68,
    columnNumber: 3
  }
}, /* @__PURE__ */ x.createElement(M.IconThreeDimensionalOutline, {
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 69,
    columnNumber: 5
  }
}), ` ${e}`), kf = ({
  text: e,
  isNewNotification: t
}) => /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
  appearance: t ? "notification" : "default",
  key: e,
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 87,
    columnNumber: 3
  }
}, /* @__PURE__ */ x.createElement(M.IconPlayCircleOutline, {
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 91,
    columnNumber: 5
  }
}), ` ${e}`), Hf = (e) => /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
  appearance: "default",
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 102,
    columnNumber: 3
  }
}, /* @__PURE__ */ x.createElement(M.IconSparkle, {
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 103,
    columnNumber: 5
  }
}), ` ${e}`), fa = ({
  text: e,
  isNewNotification: t
}) => /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
  appearance: t ? "notification" : "default",
  key: e,
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 121,
    columnNumber: 3
  }
}, e), dr = (e, t) => /* @__PURE__ */ x.createElement(M.PropertyCardBadge, {
  appearance: "zillow",
  key: e,
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 136,
    columnNumber: 3
  }
}, t ? /* @__PURE__ */ x.createElement(M.IconZillowLogo, {
  __self: void 0,
  __source: {
    fileName: F,
    lineNumber: 137,
    columnNumber: 20
  }
}) : null, t ? ` ${e}` : e), Gf = (e, {
  availabilityCount: t,
  badgeInfo: r,
  isBuilding: n
}, a = !1) => {
  const {
    type: i,
    text: o
  } = r || {};
  if (o && i) {
    if (e === "acceptsApplicationsOnly" || e === "specialOffers")
      return dr(o, a);
    if (e === "r4r")
      return fa({
        text: o,
        isNewNotification: !1
      });
    if (e === "unitAvailability" && t) {
      const u = (0, Uf.pluralize)(t, "available unit", "s");
      return dr(u, a);
    }
  }
  return null;
};
ca = Q.getRentalPropertyCardBadge = Gf;
const zf = ({
  variableData: e
}) => {
  const {
    data: t,
    type: r,
    text: n
  } = e || {}, a = r && r.includes("SEARCH_NOTIFICATION") && t && !t.isRead || !1;
  if (n && r)
    switch (r) {
      case "3D_HOME":
        return Bf(n);
      case "SEARCH_NOTIFICATION_VIDEO_WALKTHROUGH":
      case "VIDEO_WALKTHROUGH":
        return kf({
          text: n,
          isNewNotification: a
        });
      case "SEARCH_NOTIFICATION_PRICE_CHANGE":
      case "PRICE_CHANGE":
        return rt({
          text: n,
          isNewNotification: a
        });
      case "SEARCH_NOTIFICATION_PRICE_REDUCTION":
      case "PRICE_REDUCTION":
        return rt({
          isIncrease: !1,
          text: n,
          isNewNotification: a
        });
      case "SEARCH_NOTIFICATION_PRICE_INCREASE":
      case "PRICE_INCREASE":
        return rt({
          isIncrease: !0,
          text: n,
          isNewNotification: a
        });
      case "SHOWCASE":
        return Hf(n);
      default:
        return fa({
          text: n,
          isNewNotification: a
        });
    }
  return null;
};
var da = Q.getPropertyCardBadge = zf;
const jf = /* @__PURE__ */ Ue({
  __proto__: null,
  default: Q,
  get getPropertyCardBadge() {
    return da;
  },
  get getRentalPropertyCardBadge() {
    return ca;
  }
}, [Q]), Wf = /* @__PURE__ */ de(jf);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "getAdditionalBuildingUnits", {
    enumerable: !0,
    get: function() {
      return t.getAdditionalBuildingUnits;
    }
  }), Object.defineProperty(e, "getAdditionalInfo", {
    enumerable: !0,
    get: function() {
      return t.getAdditionalInfo;
    }
  }), Object.defineProperty(e, "getFormattedAddress", {
    enumerable: !0,
    get: function() {
      return t.getFormattedAddress;
    }
  }), Object.defineProperty(e, "getFormattedBedsBathsSqft", {
    enumerable: !0,
    get: function() {
      return t.getFormattedBedsBathsSqft;
    }
  }), Object.defineProperty(e, "getFormattedPrice", {
    enumerable: !0,
    get: function() {
      return n.getFormattedPrice;
    }
  }), Object.defineProperty(e, "getMonthlyCost", {
    enumerable: !0,
    get: function() {
      return n.getMonthlyCost;
    }
  }), Object.defineProperty(e, "getPropertyCardBadge", {
    enumerable: !0,
    get: function() {
      return r.getPropertyCardBadge;
    }
  }), Object.defineProperty(e, "getRentalPropertyCardBadge", {
    enumerable: !0,
    get: function() {
      return r.getRentalPropertyCardBadge;
    }
  }), Object.defineProperty(e, "getRoomInfo", {
    enumerable: !0,
    get: function() {
      return t.getRoomInfo;
    }
  });
  var t = sa, r = Wf, n = Kn;
})(Re);
const ga = ({ heroImage: e, photos: t }) => {
  var r;
  return e != null && e.highResolutionLink ? e.highResolutionLink : e != null && e.defaultLink ? e.defaultLink : t != null && t.length && ((r = t[0]) == null ? void 0 : r.url) || "";
}, Vf = ({ hdpUrl: e }) => e || "", Yf = ({ recsTags: e }) => {
  var t;
  return ((t = e == null ? void 0 : e[0]) == null ? void 0 : t.value) || "";
}, qf = ({ pslRawHomeStatus: e, pslMarketingStatus: t, pslHomeType: r }) => {
  if (t)
    return _a(t);
  switch (e) {
    case ka:
      return "New construction";
    case Ha:
      return "Auction";
    case Ga:
      return `${gr(r, !0)} for rent`;
    default:
      return `${gr(r, !1)} for sale`;
  }
}, Zf = ({ attributionInfo: e }) => e != null && e.mlsName ? `Listing provided by ${e.mlsName}` : "", Kf = ({ attributionInfo: e }) => (e == null ? void 0 : e.providerLogo) || "", Jf = (e) => {
  const t = Xf(e);
  return {
    formattedAddress: Re.getFormattedAddress(t),
    formattedPrice: Re.getFormattedPrice(t),
    formattedBdBaSqftData: Re.getFormattedBedsBathsSqft(t),
    additionalInfo: Re.getAdditionalInfo(t)
  };
}, Xf = (e) => {
  var a;
  const r = Qf(e, { address: null });
  r.countryCurrency = e.currency, r.price = e.price, r.area = e.livingAreaValue, r.beds = e.bedrooms, r.baths = e.bathrooms, r.isBuilding = void 0, (a = e.building) != null && a.buildingName && (r.buildingName = e.building.buildingName);
  const { address: n } = e;
  return n && (r.address = td(n), r.addressState = n.state), r;
}, Qf = (e, t) => {
  const { attributionInfo: r, country: n } = e;
  return r && (t.brokerName = r.brokerName, t.brokerPhone = r.brokerPhoneNumber, t.info6String = r.agentName, t.info7String = r.agentPhoneNumber, r.mlsId && (t.info1String = ed(r.mlsId, n))), t;
}, ed = (e, t) => `${t && t === "CAN" ? za : ja}${e}`, td = (e) => {
  const { streetAddress: t, city: r, state: n, zipcode: a } = e, i = r ? _a(r) : null;
  return [t, i, n, a].filter((s) => s !== null).join(", ");
}, _a = (e) => e.toLowerCase().split(" ").map((t) => t.length > 1 ? t.charAt(0).toUpperCase() + t.slice(1) : t.toUpperCase()).join(" "), gr = (e, t) => {
  switch (e) {
    case "townhome":
      return "Townhouse";
    case "land":
      return "Lot / Land";
    case "manufactured":
      return "Home";
    case "multiFamily":
      return t ? "Apartment" : "Multi-family home";
    case "apartment":
      return "Apartment";
    case "condo":
      return "Condo";
    case "singleFamily":
    default:
      return "House";
  }
}, ae = (e, t) => {
  const r = new Set(t);
  return e != null && e.pslRawHomeStatus ? r.has(e.pslRawHomeStatus) : !1;
}, ma = (e) => {
  const t = !!(e != null && e.newConstructionType), r = ae(e, ["forRent"]);
  return {
    isForSale: ae(e, [
      "fsba",
      "fsbo",
      "auction",
      "newConstruction",
      "newConstructionLot",
      "comingSoon"
    ]) || (e == null ? void 0 : e.pslProviderCategory) === "forSale" && (e == null ? void 0 : e.pslMarketingStatus) !== "closed",
    isForRent: r,
    isPending: (e == null ? void 0 : e.pslMarketingStatus) === "pending",
    isRecentlySold: ae(e, ["recentlySold"]),
    isForSaleByAgent: ae(e, ["fsba"]),
    isForSaleByOwner: ae(e, ["fsbo"]),
    isNewConstruction: t,
    isNewConstructionSpec: (e == null ? void 0 : e.newConstructionType) === "improvement",
    isNewConstructionPlan: (e == null ? void 0 : e.newConstructionType) === "representative",
    isNewConstructionLot: (e == null ? void 0 : e.newConstructionType) === "lotland",
    isComingSoon: ae(e, ["comingSoon"]),
    isNone: !(e != null && e.pslRawHomeStatus)
  };
}, rd = (e) => {
  const { isPending: t, isComingSoon: r, isForSale: n, isNewConstructionLot: a, isForRent: i, isRecentlySold: o } = ma(e);
  let u;
  return t ? u = "Pending" : r ? u = "ComingSoon" : n || a ? u = "ForSale" : i ? u = "ForRent" : o ? u = "RecentlySold" : Number(e == null ? void 0 : e.zestimate) > 0 ? u = "Zestimate" : u = "NoZestimate", u;
}, nd = (e) => ({
  isForeclosedNFS: (e == null ? void 0 : e.pslPublicForeclosureStage) === "lenderTakenPossession" && (e == null ? void 0 : e.pslRawHomeStatus) === "foreclosed",
  isPreforeclosure: (e == null ? void 0 : e.pslPublicForeclosureStage) === "noticeOfSale" || (e == null ? void 0 : e.pslPublicForeclosureStage) === "noticeOfDefault"
}), ad = (e) => {
  const { isComingSoon: t, isNewConstruction: r, isForSaleByAgent: n, isForSaleByOwner: a, isNewConstructionLot: i, isNewConstructionPlan: o, isNewConstructionSpec: u, isForRent: s, isNone: c } = ma(e), { isForeclosedNFS: l, isPreforeclosure: d } = nd(e), g = e == null ? void 0 : e.isNonOwnerOccupied;
  let f, v;
  return l ? v = "Foreclosed" : d && (v = "Pre-Foreclosure"), e != null && e.isPremierBuilder ? i ? f = "New Construction Lot Plan" : o ? f = "New Construction Plan" : u && (f = "New Construction Spec") : r ? f = "New Construction" : a ? f = "For Sale by Owner" : n ? f = "For Sale by Agent" : s ? f = "For Rent" : t ? f = "Coming Soon" : e != null && e.isRecentStatusChange && c && (f = "RecentChange"), v ? f = f ? `${v} - ${f}` : v : f || (g ? f = "Non Owner Occupied" : f = "Unknown Listed By"), f;
}, id = async (e, t, r, n, a, i, o, u) => (e.preventDefault(), e.stopPropagation(), await od({
  variables: {
    parameter: {
      propertyId: n,
      propertyIdType: "zpid"
    }
  }
}, t ? a : i, ud, sd, t, r, o, u));
async function od(e, t, r, n, a, i, o, u) {
  try {
    const s = await t(e);
    return r(s, a, i, u), s;
  } catch (s) {
    return n(s, a, o), null;
  }
}
function ud(e, t, r, n) {
  return t ? vd(r, n) : hd(r), e.data;
}
function sd(e, t, r) {
  console.error("Error occured saving home from carousel", e), r(_.createElement(Ta, { "aria-live": "polite", role: "alert", appearance: "error", body: t ? Ka : Ja }), { duration: Za });
}
const m = {
  VIEW_HOMEPAGE: "view homepage",
  CLICK_HOME_REC_PROPERTY_CARD: "click home rec property card",
  SAVE_HOME_REC: "save a home rec",
  CAROUSEL_BUTTON_CLICK: "click on carousel arrow",
  SEARCH_BAR_FOCUS: "focus on search box",
  MODULE_IMPRESSION: "module impression",
  HOME_REC_IMPRESSION: "rec impression"
}, ue = {
  clickstream_trigger: { trigger_location_nm: "home" },
  envelope: {
    event_template_version_id: "1",
    event_type_version_id: "1"
  },
  semantic: {}
}, va = [
  m.CLICK_HOME_REC_PROPERTY_CARD,
  m.SAVE_HOME_REC,
  m.SEARCH_BAR_FOCUS
], Lt = (e) => e === m.HOME_REC_IMPRESSION || e === m.MODULE_IMPRESSION, cd = (e, t) => {
  const r = {
    ...ue.envelope
  };
  return r.event_client_start_dtm = t, r.event_template_id = "20", e === m.VIEW_HOMEPAGE && (r.event_template_id = "9", r.event_type_id = "43"), e === m.CLICK_HOME_REC_PROPERTY_CARD && (r.event_type_version_id = "2", r.event_template_id = "146", r.event_type_id = "1068"), e === m.SAVE_HOME_REC && (r.event_type_version_id = "4", r.event_template_id = "268", r.event_type_id = "1087"), e === m.CAROUSEL_BUTTON_CLICK && (r.event_type_id = "1088"), e === m.SEARCH_BAR_FOCUS && (r.event_type_id = "1089"), e === m.MODULE_IMPRESSION && (r.event_type_version_id = "3", r.event_template_id = "249", r.event_type_id = "3736"), e === m.HOME_REC_IMPRESSION && (r.event_type_version_id = "2", r.event_template_id = "249", r.event_type_id = "4377"), r;
}, ld = (e, t = null, r = null, n = null) => {
  const a = {
    ...ue.clickstream_trigger
  };
  if (a.trigger_type_nm = "interaction", e === m.VIEW_HOMEPAGE && (a.trigger_type_nm = "view", a.trigger_object_nm = "no_trigger_object", a.trigger_source_nm = "home", a.input_selector_nm = "keyboard"), e && e !== m.SEARCH_BAR_FOCUS && va.includes(e))
    switch (a.trigger_object_nm = "property_card", e) {
      case m.CLICK_HOME_REC_PROPERTY_CARD:
        a.trigger_source_nm = "button_to_see_property";
        break;
      case m.SAVE_HOME_REC:
        a.trigger_source_nm = "button_to_save_home";
        break;
    }
  return a.trigger_source_nm = r, e === m.CAROUSEL_BUTTON_CLICK && (a.trigger_object_nm = "property_card_carousel", a.trigger_location_nm = n, a.input_selector_nm = t), e === m.SEARCH_BAR_FOCUS && (a.trigger_object_nm = "search_component", a.trigger_source_nm = "search_bar"), Lt(e) && (a.trigger_type_nm = "impression", a.trigger_source_nm = "home"), e === m.MODULE_IMPRESSION && (a.trigger_object_nm = "recommendations_component", a.input_selector_nm = "keyboard"), e === m.HOME_REC_IMPRESSION && (a.trigger_object_nm = "property card"), a;
}, fd = (e) => {
  const t = {
    ...ue.semantic
  };
  return t.topic_tag_txt = ["home"], e === m.VIEW_HOMEPAGE && (t.semantic_event_nm = "view_content"), e === m.CLICK_HOME_REC_PROPERTY_CARD && (t.semantic_event_nm = "see_property", t.topic_tag_txt = ["homereccard", "_home"]), e === m.SAVE_HOME_REC && (t.semantic_event_nm = "save_home"), e === m.CAROUSEL_BUTTON_CLICK && (t.semantic_event_nm = "click_see_more"), e === m.SEARCH_BAR_FOCUS && (t.semantic_event_nm = "search_box_focus"), Lt(e) && (t.semantic_event_nm = "view_content"), t;
}, Ne = (e, t, r, n = null, a = null, i = null, o = null) => {
  const u = (/* @__PURE__ */ new Date()).toISOString();
  let s = {
    ...ue,
    clickstream_trigger: { ...ue.clickstream_trigger },
    envelope: { ...ue.envelope }
  };
  if (s.envelope = cd(e, u), s.clickstream_trigger = ld(e, r, i, o), s.semantic = fd(e), e && e === m.SEARCH_BAR_FOCUS && (s = {
    ...s,
    home_page_search: {
      user_search_term_txt: t
    }
  }), e && Lt(e) && (s = {
    ...s,
    generic_collection: {
      items: [
        {
          collection_type_txt: a == null ? void 0 : a.collectionType,
          collection_title_txt: a == null ? void 0 : a.collectionTitle,
          collection_data: a == null ? void 0 : a.collection_data,
          collection_items: a == null ? void 0 : a.collection_items
        }
      ]
    }
  }), e && va.includes(e)) {
    if (e !== m.SEARCH_BAR_FOCUS) {
      const c = e === m.SAVE_HOME_REC, l = (a == null ? void 0 : a.isZillowOwned) || !1;
      s = {
        ...s,
        property_info: {
          zpid: a == null ? void 0 : a.zpid,
          video_ind: !!(a != null && a.videoId),
          zillow_owned_exp_ind: l,
          saved_ind: !!(a != null && a.isSavedByCurrentSignedInUser),
          raw_home_status_cd: c ? rd(a) : null,
          marketing_status_simplified_cd: c ? ad(a) : null
        }
      };
    }
    Fe(n, { newLaneEvent: s });
  } else {
    if (e === m.VIEW_HOMEPAGE)
      return s;
    Da(s);
  }
}, dd = (e, t, r = null) => {
  const n = [];
  t.forEach((o, u) => {
    n.push({
      zpid: o.zpid,
      rec_rank: u + 1
    });
  });
  const a = t.map((o) => o.zpid).map((o) => Number(o)).filter(ye), i = {
    zpid: a[0],
    collectionType: "collection",
    collectionTitle: e.collectionName,
    collection_data: {
      tracing_id: e.trackingTag,
      module_rank_nb: e.collectionCount
    },
    collection_items: n
  };
  Ne(m.MODULE_IMPRESSION, null, null, null, i, null, r), Fe({
    category: "HomePage",
    action: "HomeRecsReturned",
    label: `${e.collectionName}: ${a.join()}`
  }, {
    newLaneEvent: {
      clickstream_trigger: {
        trigger_location_nm: r
      }
    }
  });
}, gd = (e, t, r, n = null) => {
  var u;
  const a = {
    zpid: t.zpid,
    rec_rank: r + 1,
    displayed_image_url: ga(t)
  }, i = (u = t.recsTags) == null ? void 0 : u[0];
  i && (a.displayed_flex_spot_type = "homeInsight", a.displayed_flex_spot_value = i.value);
  const o = {
    ...t,
    collectionType: "collection",
    collectionTitle: e.collectionName,
    collection_data: {
      tracing_id: e.trackingTag,
      module_rank_nb: e.collectionCount
    },
    collection_items: [a]
  };
  Ne(m.HOME_REC_IMPRESSION, null, null, null, o, null, n);
}, _d = (e, t, r, n = null) => {
  const a = {
    category: "HomePage",
    action: "Click Mini Card",
    label: `${e} | ${t}`
  };
  Ne(m.CLICK_HOME_REC_PROPERTY_CARD, null, null, a, r, null, n);
}, md = (e, t = null) => Fe({
  category: "HomePage",
  action: "Horizontal Scroll",
  label: e
}, {
  newLaneEvent: {
    clickstream_trigger: {
      trigger_location_nm: t
    }
  }
}), vd = (e, t, r = null) => {
  const n = {
    category: "Followed Homes",
    action: "Follow Home",
    label: `HomeRecCollection | ${e}`
  };
  Ne(m.SAVE_HOME_REC, null, null, n, t, null, r);
}, se = (e, t = null, r = null) => {
  Ne(m.CAROUSEL_BUTTON_CLICK, null, e, null, null, t, r);
}, hd = (e, t = null) => Fe({
  category: "Followed Homes",
  action: "Unfollow Home",
  label: `HomeRecCollection | ${e}`
}, {
  newLaneEvent: {
    clickstream_trigger: {
      trigger_location_nm: t
    }
  }
}), pd = ({ direction: e, additionalProps: t, triggerLocation: r }) => {
  const n = e === "right", a = Ct(!0), i = W(() => {
    a.current && se("mouse", `button_arrow_to_go_${e}`, r);
  }), o = W((c) => {
    c();
  }), u = Me((c) => {
    (c.key === "Enter" || c.key === " ") && o(() => {
      se("keyboard", `button_arrow_to_go_${e}`, r);
    });
  }, [o]), s = W(() => {
    a.current = !1, se("touch", `button_arrow_to_go_${e}`, r);
  });
  return _.createElement(Na, { "aria-label": n ? "Next" : "Previous", appearance: "circle", size: "sm", icon: n ? _.createElement(Ia, null) : _.createElement(La, null), title: n ? "Next set of home recommendations" : "Previous set of home recommendations", onMouseDown: i, onKeyDown: u, onTouchStart: s, ...t });
}, _r = pr(pd), ha = ba(({ cardSize: e, title: t, subtitle: r, hasLink: n, onScroll: a, loading: i, triggerLocation: o, children: u }, s) => _.createElement(
  ie,
  { sx: {
    "li > article a": {
      "&:visited": {
        color: "$colors.black"
      }
    },
    position: "relative"
  }, ref: s, "data-testid": "home-recs-carousel" },
  _.createElement(ie, { as: $a, sx: {
    // Align first card with heading
    "> ul": {
      marginLeft: "calc(-1 * $spacing.xs)",
      overflowY: "hidden",
      // Shorten padding around link button
      "> li:last-child": n ? {
        flexBasis: "auto",
        transform: "translateY(40%)",
        paddingLeft: typeof window < "u" && window.innerWidth < Ut ? "$spacing.xs" : "$spacing.sm"
      } : {
        display: "none"
      }
    }
  }, "data-testid": "property-card-container", "aria-label": "Home Recommendations Carousel", scrollOffset: "xs", slideWidth: typeof window < "u" && window.innerWidth < Ut ? Ya : qa, heading: i ? _.createElement(
    ie,
    { sx: {
      width: 250,
      height: 48,
      borderRadius: 4,
      overflow: "hidden",
      "@media $md": {
        width: 400
      }
    } },
    _.createElement(Xa, null)
  ) : _.createElement(
    _.Fragment,
    null,
    _.createElement(ya, { as: "h5", level: "5" }, t),
    r && _.createElement(ie, { as: wa, fontColor: "textMedium", fontType: "bodySmall", sx: {
      paddingLeft: 0,
      paddingBottom: "$spacing.xs"
    } }, r)
  ), renderNavigationControls: (c, l) => _.createElement(
    ie,
    { sx: {
      display: "none",
      gridAutoFlow: "column",
      gridColumnGap: "$spacing.sm",
      alignItems: "start",
      /* show buttons only on xl and up */
      "@media $xl": {
        display: "grid"
      }
    } },
    _.createElement(_r, { direction: "left", additionalProps: c, triggerLocation: o }),
    _.createElement(_r, { direction: "right", additionalProps: l, triggerLocation: o })
  ), onScroll: a }, i ? Array.from({ length: Wa }).map((c, l) => _.createElement(K, { key: `loading-${l}`, "data-testid": `home-rec-card-${l}`, cardSize: e, data: {}, loading: !0 })) : u)
));
ha.displayName = "HomeRecsCarouselContainer";
const pa = Cr(ha);
var pt = /* @__PURE__ */ new Map(), Le = /* @__PURE__ */ new WeakMap(), mr = 0, Cd = void 0;
function Rd(e) {
  return e ? (Le.has(e) || (mr += 1, Le.set(e, mr.toString())), Le.get(e)) : "0";
}
function Sd(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? Rd(e.root) : e[t]}`).toString();
}
function Ed(e) {
  let t = Sd(e), r = pt.get(t);
  if (!r) {
    const n = /* @__PURE__ */ new Map();
    let a;
    const i = new IntersectionObserver((o) => {
      o.forEach((u) => {
        var s;
        const c = u.isIntersecting && a.some((l) => u.intersectionRatio >= l);
        e.trackVisibility && typeof u.isVisible > "u" && (u.isVisible = c), (s = n.get(u.target)) == null || s.forEach((l) => {
          l(c, u);
        });
      });
    }, e);
    a = i.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), r = {
      id: t,
      observer: i,
      elements: n
    }, pt.set(t, r);
  }
  return r;
}
function bd(e, t, r = {}, n = Cd) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const s = e.getBoundingClientRect();
    return t(n, {
      isIntersecting: n,
      target: e,
      intersectionRatio: typeof r.threshold == "number" ? r.threshold : 0,
      time: 0,
      boundingClientRect: s,
      intersectionRect: s,
      rootBounds: s
    }), () => {
    };
  }
  const { id: a, observer: i, elements: o } = Ed(r);
  let u = o.get(e) || [];
  return o.has(e) || o.set(e, u), u.push(t), i.observe(e), function() {
    u.splice(u.indexOf(t), 1), u.length === 0 && (o.delete(e), i.unobserve(e)), o.size === 0 && (i.disconnect(), pt.delete(a));
  };
}
function Ca({
  threshold: e,
  delay: t,
  trackVisibility: r,
  rootMargin: n,
  root: a,
  triggerOnce: i,
  skip: o,
  initialInView: u,
  fallbackInView: s,
  onChange: c
} = {}) {
  var l;
  const [d, g] = pe.useState(null), f = pe.useRef(), [v, C] = pe.useState({
    inView: !!u,
    entry: void 0
  });
  f.current = c, pe.useEffect(
    () => {
      if (o || !d)
        return;
      let N;
      return N = bd(
        d,
        (I, T) => {
          C({
            inView: I,
            entry: T
          }), f.current && f.current(I, T), T.isIntersecting && i && N && (N(), N = void 0);
        },
        {
          root: a,
          rootMargin: n,
          threshold: e,
          // @ts-ignore
          trackVisibility: r,
          // @ts-ignore
          delay: t
        },
        s
      ), () => {
        N && N();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(e) ? e.toString() : e,
      d,
      a,
      n,
      i,
      o,
      r,
      s,
      t
    ]
  );
  const E = (l = v.entry) == null ? void 0 : l.target, A = pe.useRef();
  !d && E && !i && !o && A.current !== E && (A.current = E, C({
    inView: !!u,
    entry: void 0
  }));
  const h = [g, v.inView, v.entry];
  return h.ref = h[0], h.inView = h[1], h.entry = h[2], h;
}
var Ad = /\s/;
function Pd(e) {
  for (var t = e.length; t-- && Ad.test(e.charAt(t)); )
    ;
  return t;
}
var Od = /^\s+/;
function Td(e) {
  return e && e.slice(0, Pd(e) + 1).replace(Od, "");
}
var vr = 0 / 0, Nd = /^[-+]0x[0-9a-f]+$/i, Id = /^0b[01]+$/i, Ld = /^0o[0-7]+$/i, $d = parseInt;
function hr(e) {
  if (typeof e == "number")
    return e;
  if (De(e))
    return vr;
  if (le(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = le(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Td(e);
  var r = Id.test(e);
  return r || Ld.test(e) ? $d(e.slice(2), r ? 2 : 8) : Nd.test(e) ? vr : +e;
}
var yd = function() {
  return H.Date.now();
};
const nt = yd;
var wd = "Expected a function", xd = Math.max, Md = Math.min;
function Fd(e, t, r) {
  var n, a, i, o, u, s, c = 0, l = !1, d = !1, g = !0;
  if (typeof e != "function")
    throw new TypeError(wd);
  t = hr(t) || 0, le(r) && (l = !!r.leading, d = "maxWait" in r, i = d ? xd(hr(r.maxWait) || 0, t) : i, g = "trailing" in r ? !!r.trailing : g);
  function f(R) {
    var L = n, B = a;
    return n = a = void 0, c = R, o = e.apply(B, L), o;
  }
  function v(R) {
    return c = R, u = setTimeout(A, t), l ? f(R) : o;
  }
  function C(R) {
    var L = R - s, B = R - c, Z = t - L;
    return d ? Md(Z, i - B) : Z;
  }
  function E(R) {
    var L = R - s, B = R - c;
    return s === void 0 || L >= t || L < 0 || d && B >= i;
  }
  function A() {
    var R = nt();
    if (E(R))
      return h(R);
    u = setTimeout(A, C(R));
  }
  function h(R) {
    return u = void 0, g && n ? f(R) : (n = a = void 0, o);
  }
  function N() {
    u !== void 0 && clearTimeout(u), c = 0, n = s = a = u = void 0;
  }
  function I() {
    return u === void 0 ? o : h(nt());
  }
  function T() {
    var R = nt(), L = E(R);
    if (n = arguments, a = this, s = R, L) {
      if (u === void 0)
        return v(s);
      if (d)
        return clearTimeout(u), u = setTimeout(A, t), f(s);
    }
    return u === void 0 && (u = setTimeout(A, t)), o;
  }
  return T.cancel = N, T.flush = I, T;
}
const Ud = ({ linkData: e, triggerLocation: t }) => {
  const r = Ct(!0);
  if (!e)
    return null;
  const { displayText: n, url: a } = e, i = () => {
    global.window.open(a, "_self");
  }, o = W(() => {
    r.current && se("mouse", "collection_see_more", t), i();
  }), u = W((l) => {
    l();
  }), s = Me((l) => {
    (l.key === "Enter" || l.key === " ") && u(() => {
      se("keyboard", "collection_see_more", t), i();
    });
  }, [u]), c = W(() => {
    r.current = !1, se("touch", "collection_see_more", t), i();
  });
  return _.createElement(xa, { "data-testid": "carousel-link-btn", icon: _.createElement(Ma, null), iconPosition: "end", onMouseDown: o, onKeyDown: s, onTouchStart: c }, n);
}, Dd = pr(Ud), Bd = ({ propertyData: e, cardIndex: t, handleSaveButtonClick: r, savedHomeMapByZpid: n, shouldShowPhotoCarousel: a = !1, loggedIn: i, collectionName: o, trackingTag: u, collectionCount: s, triggerLocationNM: c, cardSize: l = "large", loading: d }) => {
  const g = {
    collectionName: o,
    trackingTag: u,
    collectionCount: s
  }, f = e.zpid;
  if (!f)
    throw new Error("zpid is required for HomeRecCard");
  const v = e.photos, C = Vf(e), E = Yf(e), A = ga(e), { formattedAddress: h, formattedPrice: N, formattedBdBaSqftData: I, additionalInfo: T } = Jf(e), R = W(() => {
    const { window: S } = global, w = {
      ...e,
      collection_items: [
        {
          rec_rank: s
        }
      ]
    };
    Ba(w), _d(o, f, w, c), setTimeout(() => {
      S.open(`${S.location.origin + C}`, "_self");
    }, 50);
  }), L = E ? _.createElement(K.Badge, { "data-testid": "property-card-badge" }, E) : null, B = {
    title: N,
    body1: I != null && I.length ? _.createElement(K.HomeDetailsList, { data: I }) : null,
    body2: {
      // Rendered as a link for SEO
      as: "a",
      children: _.createElement("address", null, h),
      href: C,
      style: { textDecoration: "none" },
      tabIndex: -1
    },
    body3: qf(e),
    additionalInfo: T ? {
      children: T,
      lineClamp: 2
    } : null,
    mls: {
      attribution: Zf(e),
      logoSrc: Kf(e)
    }
  }, [Z, $] = Ca({
    root: null,
    threshold: 1,
    triggerOnce: !0,
    skip: typeof (window == null ? void 0 : window.IntersectionObserver) > "u"
  });
  at(() => {
    $ && gd(g, e, t, c);
  }, [$]);
  const y = W((S, w) => (r(S, {
    pressed: w,
    cardIndex: t,
    zpid: f,
    propertyData: e
  }), [r, t, f, e]));
  return _.createElement(
    K,
    {
      // Remove "group" as lighthouse flagging <article> combo.
      role: void 0,
      ref: Z,
      "data-testid": `home-rec-card-${t}`,
      "aria-label": h,
      badge: L,
      data: B,
      onClick: R,
      appearance: l,
      loading: d,
      photoBody: a ? _.createElement(Fa, { "data-testid": "property-card-photo-carousel" }, v == null ? void 0 : v.map((S, w) => _.createElement(
        Mt,
        { href: C, key: `${S == null ? void 0 : S.url}${w}`, tabIndex: "-1", "aria-hidden": "false", style: {
          display: "block",
          height: "100%"
        } },
        _.createElement(K.Photo, { "data-testid": `carousel-photo-${w}`, alt: h, key: w + ((S == null ? void 0 : S.url) || "empty-url"), src: S == null ? void 0 : S.url })
      ))) : _.createElement(
        Mt,
        { href: C, tabIndex: "-1", "aria-hidden": "false", style: { display: "block", height: "100%" } },
        _.createElement(K.Photo, { "data-testid": "property-card-photo", src: A, alt: h })
      ),
      saveButton: i ? _.createElement(K.SaveButton, { "data-testid": "property-card-save", pressed: n[f], onClick: (S, w) => {
        y(S, w);
      } }) : null
    }
  );
}, kd = Rr`
  mutation SaveHomeFromCarousel($parameter: SavedHomeInput!) {
    saveOrUpdateHome(savedHomeInput: $parameter)
  }
`, Hd = kd, Gd = Rr`
  mutation UnsaveHomeFromCarousel($parameter: RemoveSavedHomeInput!) {
    removeSavedHome(removeSavedHomeInput: $parameter)
  }
`, zd = Gd;
function jd({ propertyLimit: e, zpidList: t, propertyData: r }) {
  return e >= 1 && !!t.length && r.length >= Va;
}
const Wd = (e) => {
  var B, Z;
  const { loggedIn: t, propertyLimit: r, enqueueToast: n, shouldShowHomeRecsPhotoCarousel: a, collectionCount: i, collection: o, triggerLocation: u, cardSize: s = "large", propertyData: c, zpidList: l } = e, d = (o == null ? void 0 : o.name) || "", g = (o == null ? void 0 : o.caption) || "", f = ((Z = (B = o.trackingTags) == null ? void 0 : B[0]) == null ? void 0 : Z.value) || "", v = {
    collectionType: "collection",
    collectionTitle: d,
    collection_data: {
      tracing_id: f,
      module_rank_nb: i
    },
    collection_items: [{ rec_rank: i }]
  }, [C, E] = Aa({}), A = Ct(!1), h = Me(Fd(() => {
    A.current || md(d), A.current = !0;
  }, 1e3), []), N = Pa(() => c.filter(ye).filter(($) => !!$.zpid).slice(0, r), [r, c]);
  at(() => {
    if (c != null && c.length && r) {
      const $ = {};
      N.forEach((y) => {
        y.zpid && ($[y.zpid] = !!y.isSavedByCurrentSignedInUser);
      }), E($);
    }
  }, [c, r]);
  const [I, T] = Ca({
    root: null,
    threshold: 1,
    triggerOnce: !0,
    skip: typeof (window == null ? void 0 : window.IntersectionObserver) > "u"
  });
  at(() => {
    T && dd({
      collectionName: d,
      trackingTag: f,
      collectionCount: i
    }, N.map((y) => y != null && y.zpid ? { zpid: y.zpid } : null).filter(ye));
  }, [T]);
  const [R] = Ft(Hd), [L] = Ft(zd);
  return jd({ propertyLimit: r, propertyData: c, zpidList: l }) ? _.createElement(
    pa,
    { onScroll: h, title: d, subtitle: g, hasLink: !!o.link, triggerLocation: u, cardSize: s, ref: I },
    N.map(($, y) => {
      var $t;
      const S = ($t = o.recs) == null ? void 0 : $t.find((ve) => {
        var he;
        return ((he = ve == null ? void 0 : ve.id) == null ? void 0 : he.value) === String($.zpid);
      }), w = {
        ...$,
        heroImage: S == null ? void 0 : S.heroImage,
        recsTags: S == null ? void 0 : S.recsTags
      };
      return _.createElement(Bd, {
        key: `${d}-${$.zpid}`,
        propertyData: w,
        cardIndex: y,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        handleSaveButtonClick: async (ve, { pressed: he, cardIndex: Ra, zpid: yt, propertyData: Sa }) => {
          var wt, xt;
          const Ea = {
            ...Sa,
            ...v
          }, ne = await id(ve, !he, Ra, yt, R, L, n, Ea);
          ((wt = ne == null ? void 0 : ne.data) != null && wt.saveOrUpdateHome || (xt = ne == null ? void 0 : ne.data) != null && xt.removeSavedHome) && E({
            ...C,
            [yt]: !he
          });
        },
        savedHomeMapByZpid: C,
        shouldShowPhotoCarousel: a,
        loggedIn: t,
        collectionName: d,
        trackingTag: f,
        collectionCount: i,
        triggerLocationNM: u,
        cardSize: s,
        loading: !1
      });
    }),
    _.createElement(Dd, { linkData: o.link, triggerLocation: u })
  ) : null;
}, Vd = Wd, Yd = (e) => {
  var o, u;
  const { loading: t, triggerLocation: r, cardSize: n = "large", collection: a } = e;
  if (t)
    return _.createElement(pa, { loading: !0, cardSize: n, triggerLocation: r });
  const i = (o = a == null ? void 0 : a.recs) == null ? void 0 : o.map((s) => {
    var c;
    return Number((c = s == null ? void 0 : s.id) == null ? void 0 : c.value);
  }).filter(ye);
  return !(i != null && i.length) || !((u = a == null ? void 0 : a.propertyDetails) != null && u.length) ? null : _.createElement(Vd, { ...e, propertyData: a.propertyDetails, zpidList: i, collection: a });
}, Qd = Cr(Ua(Yd));
export {
  Qd as RecsCarousel
};
//# sourceMappingURL=home-recs-carousels.es.js.map
